module.exports = __webpack_public_path__ + "img/forest-footer.d40ff264.png";